var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuntimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10251_33357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9.72803C2 10.516 2.15519 11.2962 2.45672 12.0241C2.75825 12.7521 3.20021 13.4135 3.75736 13.9707C4.31451 14.5278 4.97595 14.9698 5.7039 15.2713C6.43185 15.5728 7.21207 15.728 8 15.728C8.78793 15.728 9.56815 15.5728 10.2961 15.2713C11.0241 14.9698 11.6855 14.5278 12.2426 13.9707C12.7998 13.4135 13.2417 12.7521 13.5433 12.0241C13.8448 11.2962 14 10.516 14 9.72803C14 8.9401 13.8448 8.15988 13.5433 7.43193C13.2417 6.70397 12.7998 6.04254 12.2426 5.48539C11.6855 4.92824 11.0241 4.48628 10.2961 4.18475C9.56815 3.88322 8.78793 3.72803 8 3.72803C7.21207 3.72803 6.43185 3.88322 5.7039 4.18475C4.97595 4.48628 4.31451 4.92824 3.75736 5.48539C3.20021 6.04254 2.75825 6.70397 2.45672 7.43193C2.15519 8.15988 2 8.9401 2 9.72803Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.22803L13.25 3.97803",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3.72803L13.5 4.22803",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.72803V0.728027",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.728027H6.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.2283L5.5 7.46094",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10251_33357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.228027)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuntimeIcon);
export default __webpack_public_path__ + "static/media/Runtime_icon.8afd067d.svg";
export { ForwardRef as ReactComponent };